var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgU1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00004,
    cy: 3.80604,
    r: 2.89121,
    stroke: "#363636",
    strokeWidth: 1.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.8625 12.578C0.8625 10.6726 2.40712 9.12802 4.3125 9.12802H9.6875C11.5929 9.12802 13.1375 10.6726 13.1375 12.578V13.6352C13.1375 14.436 12.4883 15.0852 11.6875 15.0852H2.3125C1.51169 15.0852 0.8625 14.436 0.8625 13.6352V12.578Z",
    stroke: "#363636",
    strokeWidth: 1.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU1);
export default __webpack_public_path__ + "static/media/u1.1e5d5e2aee95d2028d2cbcfde8759976.svg";
export { ForwardRef as ReactComponent };